import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import WhatsApp from "../../assets/whatsapp.png";

import { useNavigate } from "react-router-dom";

import aboutHero from "../../assets/ramayanaTour-hero.jpg";

import dhamma from "../../assets/nallur.jpg";
import sigiriya from "../../assets/Seetha_Amman_Temple_Seetha_Eliya.jpg";
import kandy from "../../assets/ella-ravana-falls.jpg";
import temple from "../../assets/katharagama-1.jpg";

function RamayanaTour() {

    const navigate = useNavigate();

    const images = [dhamma, sigiriya, kandy, temple];

    const [selectedImage, setSelectedImage] = useState(images[0]);

    const [day1, setDay1] = useState(true);
    const [day2, setDay2] = useState(false);
    const [day3, setDay3] = useState(false);
    const [day4, setDay4] = useState(false);
    const [day5, setDay5] = useState(false);
    const [day6, setDay6] = useState(false);
    const [day7, setDay7] = useState(false);
    const [day8, setDay8] = useState(false);
    const [day9, setDay9] = useState(false);
    const [day10, setDay10] = useState(false);

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${aboutHero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white">
                    <h1
                        data-aos="fade-up"
                        className="text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Ramayana Tour
                    </h1>
                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mt-4 sm:mt-6 max-w-full sm:max-w-2xl md:max-w-3xl text-sm sm:text-base md:text-lg"
                    >
                        Discover the legendary Ramayana Trail, where ancient history, culture, and natural beauty come together in a magical journey across Sri Lanka.
                    </p>
                </div>
            </section>

            {/* ================= CULTURAL HIGHLIGHTS ================= */}
            <section className="bg-white -py-2">
                <div className="mx-auto max-w-7xl px-6 text-center">

                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mx-auto mt-6 max-w-4xl text-gray-600 leading-relaxed"
                    >
                        Embark on a unique journey through Sri Lanka, exploring the sacred Ramayana Trail and the cultural richness of Jaffna. Discover ancient legends connected to Lord Rama, Sita, and Ravana as you visit iconic Ramayana sites such as Munneswaram Temple, Seetha Amman Temple in Nuwara Eliya, Ashok Vatika (Hakgala), Ravana Falls, and Divurumpola. Continue your journey north to Jaffna, a vibrant cultural hub known for its historic temples, Jaffna Fort, Nallur Kandaswamy Kovil, and authentic Tamil heritage. This tour blends mythology, spirituality, and cultural discovery, offering a truly meaningful Sri Lankan experience.
                    </p>

                    {/* Duration Bar */}
                    <div
                        data-aos="fade-up"
                        data-aos-delay="250"
                        className="mx-auto mt-10 flex max-w-4xl items-center justify-center rounded-md bg-gradient-to-r from-[#0A3A5E] to-[#1C6EA4] py-5 text-white"
                    >
                        <div className="flex items-center gap-4">
                            <span className="text-3xl">📅</span>
                            <div className="text-left">
                                <p className="text-sm uppercase tracking-widest">Duration</p>
                                <p className="text-xl font-bold">10 Days / 9 Nights</p>
                            </div>
                        </div>
                    </div>

                    {/* Main Image */}
                    <div
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        className="mx-auto mt-10 overflow-hidden rounded-xl shadow-xl"
                    >
                        <img
                            src={selectedImage}
                            alt="Selected Tour"
                            className="w-full h-[250px] sm:h-[350px] md:h-[450px] lg:h-[600px] xl:h-[720px] object-cover transition duration-500"
                        />
                    </div>

                    {/* Thumbnail Gallery */}
                    <div
                        data-aos="fade-up"
                        data-aos-delay="400"
                        className="mx-auto mt-8 grid max-w-5xl grid-cols-2 gap-4 sm:grid-cols-4"
                    >
                        {images.map((img, index) => (
                            <img
                                key={index}
                                src={img}
                                onClick={() => setSelectedImage(img)}
                                className={`h-28 w-full cursor-pointer rounded-lg object-cover transition-all duration-300 
                                hover:scale-105
                                ${selectedImage === img ? "ring-4 ring-[#0A3A5E]" : "opacity-70"}
                            `}
                            />
                        ))}
                    </div>

                </div>
            </section>

            {/* ================= TOUR ITINERARY ================= */}
            <section className="bg-gray-50 py-10">
                <div className="mx-auto max-w-6xl px-6">

                    <h2
                        data-aos="fade-up"
                        className="text-center text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Tour Itinerary
                    </h2>

                    <div className="mt-12 space-y-6">

                        {/* ================= DAY 1 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay1(!day1)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 1: Arrival in Colombo & Kelaniya Temple</span>
                                <span>{day1 ? "−" : "+"}</span>
                            </button>

                            {day1 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Arrival at Colombo International Airport and meet & greet.</p>
                                    <p>Visit <b>Kelaniya Temple</b> – Ancient temple linked to Ramayana era.</p>
                                    <p>City tour of Colombo (optional).</p>
                                    <p className="font-semibold">Overnight stay in Colombo.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 2 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay2(!day2)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 2: Colombo → Munneswaram Temple → Wilpattu</span>
                                <span>{day2 ? "−" : "+"}</span>
                            </button>

                            {day2 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Visit <b>Munneswaram Temple</b> – One of the key Ramayana-linked shrines.</p>
                                    <p>Continue to Wilpattu National Park for evening safari.</p>
                                    <p>Wildlife safari experience (leopard, elephant spotting).</p>
                                    <p className="font-semibold">Overnight stay near Wilpattu / Anuradhapura.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 3 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay3(!day3)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 3: Wilpattu → Anuradhapura → Jaffna</span>
                                <span>{day3 ? "−" : "+"}</span>
                            </button>

                            {day3 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Explore sacred city of Anuradhapura (optional short visit).</p>
                                    <p>Transfer to <b>Jaffna</b> – cultural journey to Northern Sri Lanka.</p>
                                    <p className="font-semibold">Overnight stay in Jaffna.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 4 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay4(!day4)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 4: Explore Jaffna</span>
                                <span>{day4 ? "−" : "+"}</span>
                            </button>

                            {day4 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Visit <b>Nallur Kandaswamy Kovil</b> and Jaffna Fort.</p>
                                    <p>Explore local culture, markets, and Jaffna Library.</p>
                                    <p>Relax at Casuarina Beach.</p>
                                    <p className="font-semibold">Overnight stay in Jaffna.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 5 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay5(!day5)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 5: Jaffna → Sigiriya</span>
                                <span>{day5 ? "−" : "+"}</span>
                            </button>

                            {day5 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Long scenic transfer to Sigiriya.</p>
                                    <p>Relax and village surroundings experience.</p>
                                    <p className="font-semibold">Overnight stay in Sigiriya.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 6 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay6(!day6)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 6: Sigiriya Rock Fortress</span>
                                <span>{day6 ? "−" : "+"}</span>
                            </button>

                            {day6 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Climb <b>Sigiriya Rock Fortress</b>.</p>
                                    <p>Optional village tour and cultural experience.</p>
                                    <p className="font-semibold">Overnight stay in Sigiriya.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 7 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay7(!day7)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 7: Sigiriya → Kandy</span>
                                <span>{day7 ? "−" : "+"}</span>
                            </button>

                            {day7 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Visit <b>Divurumpola Temple</b> – Site of Sita’s Agni Pariksha.</p>
                                    <p>Arrive in Kandy and visit Temple of Tooth Relic.</p>
                                    <p className="font-semibold">Overnight stay in Kandy.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 8 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay8(!day8)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 8: Kandy → Nuwara Eliya (Seetha Amman Temple & Ashok Vatika)</span>
                                <span>{day8 ? "−" : "+"}</span>
                            </button>

                            {day8 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Visit <b>Seetha Amman Temple</b> – Believed site of Sita’s captivity.</p>
                                    <p>Explore <b>Hakgala Botanical Garden (Ashok Vatika)</b>.</p>
                                    <p>Continue to Nuwara Eliya hill country.</p>
                                    <p className="font-semibold">Overnight stay in Nuwara Eliya.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 9 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay9(!day9)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 9: Ravana Falls → Kataragama → South Coast</span>
                                <span>{day9 ? "−" : "+"}</span>
                            </button>

                            {day9 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Visit <b>Ravana Falls & Ravana Cave (Ella)</b>.</p>
                                    <p>Visit <b>Kataragama Temple</b> – Sacred pilgrimage site.</p>
                                    <p>Travel to southern beach area.</p>
                                    <p className="font-semibold">Overnight stay in Mirissa / Galle.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 10 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay10(!day10)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 10: Departure from Colombo</span>
                                <span>{day10 ? "−" : "+"}</span>
                            </button>

                            {day10 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Transfer to Colombo Airport for departure.</p>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </section>

            {/* ================= ROUTE MAP ================= */}
            <section className="bg-white -py-2">
                <div className="mx-auto max-w-7xl px-6">

                    <div
                        className="ch-left mx-auto max-w-5xl"
                        data-aos="fade-right"
                    >
                        <h1
                            data-aos="fade-up"
                            className="mb-6 text-center text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                        >
                            Route
                        </h1>

                        <div className="flex flex-col lg:flex-row gap-6">

                            {/* Map */}
                            <div className="map-container flex-1 overflow-hidden rounded-xl shadow-xl border">
                                <iframe
                                    width="100%"
                                    height="450"
                                    style={{ border: 0 }}
                                    loading="lazy"
                                    allowFullScreen
                                    src="https://www.google.com/maps/embed/v1/directions?key=AIzaSyDZqfXy1xcje1qgbyaF-Kb_qoRtUJc_lik
                                    &origin=Colombo,Sri+Lanka
                                    &destination=Colombo,Sri+Lanka
                                    &waypoints=Kelaniya+Temple,Sri+Lanka|
                                    Munneswaram+Temple,Sri+Lanka|
                                    Wilpattu+National+Park,Sri+Lanka|
                                    Jaffna,Sri+Lanka|
                                    Sigiriya,Sri+Lanka|
                                    Kandy,Sri+Lanka|
                                    Seetha+Amman+Temple+Nuwara+Eliya,Sri+Lanka|
                                    Hakgala+Botanical+Garden,Sri+Lanka|
                                    Ravana+Falls+Ella,Sri+Lanka|
                                    Kataragama+Temple,Sri+Lanka|
                                    Mirissa,Sri+Lanka
                                    &avoid=tolls|highways"
                                ></iframe>
                            </div>

                            {/* Route Info */}
                            <div className="route-info w-full h-[100px] lg:w-[300px] flex flex-col items-start gap-3 rounded-lg bg-gray-100 p-5 text-lg shadow">
                                <p><strong>Distance:</strong> ~1,250 km</p>
                                <p><strong>Duration:</strong> 10 Days</p>
                            </div>

                        </div>

                    </div>

                </div>
            </section>

            {/* ================= IMPORTANT INFO + CTA ================= */}
            <section className="bg-white py-10">
                <div className="mx-auto max-w-7xl px-6">

                    {/* Important Points */}
                    <div data-aos="fade-up" className="mx-auto max-w-4xl">
                        <h3 className="mb-6 text-center text-2xl font-bold text-[#0A3A5E]">
                            Important points to note
                        </h3>

                        <ul className="space-y-4 text-gray-700">
                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    After making the payment, any booking cannot be cancelled.
                                    Hence, once the payment is made it will not be refunded.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    Additional services and excursions that are optional may be provided,
                                    though for an additional charge.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    The official check-in time at all hotels is at 12:00 pm.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    The official check-out time at all hotels is at 11:00 am.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    Visits to wildlife parks will be at one’s own risk. Jeeps and vehicles
                                    available here are without air conditioning and come with basic insurance
                                    covers (not comprehensive as in the case of vehicles used for our tours).
                                </p>
                            </li>
                        </ul>
                    </div>

                    {/* CTA Box */}
                    <div
                        data-aos="zoom-in"
                        className="mt-10 w-full rounded-lg bg-gray-100 px-6 py-10 text-center shadow"
                    >
                        <h2 className="mb-6 text-xl sm:text-2xl font-semibold text-gray-800">
                            Experience your dream holiday in Sri Lanka!
                        </h2>

                        <button
                            onClick={() => navigate(`/book-now`)}
                            className="rounded-full bg-[#00A9C7] px-10 py-3 text-white font-semibold transition hover:bg-[#008eaa]">
                            BEGIN YOUR JOURNEY
                        </button>
                    </div>

                    {/* Related Destinations */}
                    <div data-aos="fade-up" className="mt-10 text-left">
                        <h3 className="mb-6 text-xl font-bold text-gray-700">
                            RELATED DESTINATIONS
                        </h3>

                        <div className="flex flex-wrap justify-start gap-3">
                            {[
                                "Kelaniya Temple",
                                "Munneswaram Temple",
                                "Wilpattu Safari",
                                "Jaffna",
                                "Sigiriya",
                                "Kandy",
                                "Seetha Amman Temple (Nuwara Eliya)",
                                "Hakgala (Ashok Vatika)",
                                "Ravana Falls",
                                "Kataragama",
                                "South Coast (Mirissa)"
                            ].map((place, i) => (
                                <span
                                    key={i}
                                    className="rounded-full bg-gray-200 px-5 py-2 text-sm font-medium text-gray-700 transition hover:bg-[#0A3A5E] hover:text-white cursor-pointer"
                                >
                                    {place}
                                </span>
                            ))}
                        </div>
                    </div>

                </div>
            </section>

            {/* ================= WHATSAPP BUTTON ================= */}
            <a
                href="https://wa.me/94769245905"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src={require("../../assets/whatsapp.png")}
                    alt="WhatsApp Icon"
                    className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
                />
            </a>

        </div>
    );
}

export default RamayanaTour;
